import React from 'react';

function RublIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="11"
        fill="none"
        viewBox="0 0 7 11"
      >
        <path
          fill="#686868"
          d="M4.867 9.12H2.393V11H1.025V9.12H.103V8.054h.922V7.035H.103V5.97h.922V.985C1.545.963 1.96.947 2.27.938c.314-.014.524-.021.628-.021.648 0 1.222.06 1.723.178.501.118.925.298 1.272.54.346.237.608.538.786.902.182.36.273.784.273 1.272 0 .56-.075 1.045-.225 1.456-.146.405-.37.74-.67 1.005-.301.26-.68.453-1.135.58-.451.124-.982.185-1.593.185h-.936v1.019h2.474V9.12zM2.393 2.188v3.78h.916c.423 0 .779-.04 1.066-.122.292-.087.526-.214.704-.383.178-.169.305-.378.383-.629a3.04 3.04 0 00.116-.882 1.83 1.83 0 00-.164-.8 1.462 1.462 0 00-.478-.574 2.108 2.108 0 00-.766-.342 4.153 4.153 0 00-1.032-.116 2.96 2.96 0 00-.322.02c-.123.01-.264.026-.423.048z"
        ></path>
      </svg>
    );
  }

  export default RublIcon;